import { IconButton, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { Node } from '../styled';
export const StyledIconButton = styled(IconButton) `
  display: none;
  margin-left: ${theme.spacing.md};
`;
export const StyledNode = styled(Node) `
  &:hover {
    ${StyledIconButton} {
      display: flex;
    }
  }
`;
